module.exports = __webpack_public_path__ + "01_mole.56a5b9b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer2/01_mole.png
// module id = kKnG
// module chunks = 0